import React from "react";

const CartIcon = ({ width, height, color }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9688 5.25H13.5312V4.78125C13.5303 3.59918 13.068 2.46416 12.2428 1.61784C11.4176 0.771515 10.2946 0.28074 9.11289 0.25H8.88711C7.70544 0.28074 6.58244 0.771515 5.75721 1.61784C4.93197 2.46416 4.46967 3.59918 4.46875 4.78125V5.25H1.03125C0.98981 5.25 0.950067 5.26646 0.920765 5.29576C0.891462 5.32507 0.875 5.36481 0.875 5.40625V17.125C0.875 17.2908 0.940848 17.4497 1.05806 17.5669C1.17527 17.6842 1.33424 17.75 1.5 17.75H16.5C16.6658 17.75 16.8247 17.6842 16.9419 17.5669C17.0592 17.4497 17.125 17.2908 17.125 17.125V5.40625C17.125 5.36481 17.1085 5.32507 17.0792 5.29576C17.0499 5.26646 17.0102 5.25 16.9688 5.25ZM6.03125 4.82031C6.03125 3.18594 7.33633 1.82969 8.9707 1.8125C9.36291 1.80905 9.75192 1.88326 10.1153 2.03087C10.4787 2.17848 10.8093 2.39656 11.088 2.67253C11.3667 2.94851 11.588 3.27693 11.7392 3.63885C11.8903 4.00077 11.9684 4.38903 11.9688 4.78125V5.25H6.03125V4.82031ZM12.125 12.125H9.625V14.625H8.375V12.125H5.875V10.875H8.375V8.375H9.625V10.875H12.125V12.125Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default CartIcon;
